const translation = {
  daysInWeek: {
    Thu: 'Czw',
    Tue: 'Wtorek',
    Mon: 'Mon',
    Sun: 'Słońce',
    Fri: 'Wolny',
    Sat: 'Sat',
    Wed: 'Środa',
  },
  months: {
    July: 'lipiec',
    January: 'Styczeń',
    August: 'Sierpień',
    February: 'Luty',
    October: 'Październik',
    April: 'Kwiecień',
    December: 'Grudzień',
    March: 'Marzec',
    May: 'Maj',
    September: 'Wrzesień',
    June: 'Czerwiec',
    November: 'Listopad',
  },
  operation: {
    cancel: 'Anuluj',
    pickDate: 'Wybierz datę',
    now: 'Teraz',
    ok: 'OK',
  },
  title: {
    pickTime: 'Wybierz czas',
  },
  defaultPlaceholder: 'Wybierz czas...',
}

export default translation
